import { APIHelper } from '@/services/axios';

const getNotifications = params => APIHelper.get('/user/notification', { params });

const readNotification = data => APIHelper.post('/user/read/notification', data);

export {
  getNotifications,
  readNotification,
};
